import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagMR = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#496E2D",
  d: "M25 50c13.807 0 25-11.193 25-25S38.806 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M25 28.881c-4.163 0-7.64-2.925-8.494-6.832A8.695 8.695 0 0 0 25 32.608a8.695 8.695 0 0 0 8.494-10.559c-.853 3.907-4.33 6.832-8.493 6.832Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "m25 17.391.81 2.492h2.62l-2.12 1.539.81 2.491-2.12-1.54-2.119 1.54.81-2.491-2.12-1.54h2.62l.81-2.49Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M25.072 50c8.563 0 16.12-4.306 20.625-10.87H4.448C8.954 45.695 16.51 50 25.072 50ZM25.072 0c8.563 0 16.12 4.306 20.625 10.87H4.448C8.954 4.306 16.51 0 25.072 0Z"
}));
FlagMR.displayName = 'FlagMR';
export default withFlagWrapper(FlagMR);
//# sourceMappingURL=index.js.map